import React, { Component } from 'react';
import { Box,Button,CircularProgress,IconButton, Menu, MenuItem, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { ChevronRightRounded, MoreVertRounded, PrintRounded, QrCode2Rounded } from '@mui/icons-material';
import GenerateQrCode from './GenerateQrCode';
import { find, isEmpty, uniqBy } from 'lodash';
import { green, grey, red } from '@mui/material/colors';
import Equipements from '../Forms/Equipements';
import EquipementPics from '../Forms/EquipementPics';
import TableWithFilters from '../../../common/TableWithFilters';
import DeleteDialog from '../../../common/DeleteDialog';
import axios from 'axios';
import PrintRefs from '../Print/PrintRefs';


class ImmoList extends Component {
    state = { 
        type: "",
        openQR: false,
        selected: {},
        openFilters: false,
        openUpdate: false,
        openUpdatePics: false,
        anchorEl: null, 
        openMenu: "", 
        openDelete: false, 
        toDelete: {},
    }

    handleOpenUpdate = (data, form = "openUpdate", open = true) => {
        this.setState({
			selected: data ,
            [form]: open,
            openMenu: "",
            anchorEl: null
		})
    }
    handleDelete = async () => {
        const { selected } = this.state;
        await this.props.deleteEquipement(selected)
        if(this.props.STATE.equipements.error){
            this.props.notif("error", this.props.STATE.equipements.error)
        } else {
            this.props.notif("success", "Équipement supprimé")
            this.setState({
                openDelete: false,
                selected: {},
            })
        }
    }
    // getRowStyle = (params) => {
    //     console.log('===================get qty=================');
    //     console.log(params.getValue(params.id, 'equipement_quantity'));
    //     console.log('====================================');
    //     if (params.getValue(params.id, 'equipement_quantity') > 1) {
    //         return { backgroundColor: grey[50] };
    //     }  else {
    //         const value = params.getValue(params.id, 'equipement_available');
    //         console.log('====================================');
    //         console.log({value});
    //         console.log('====================================');
    //         if (value === false) {
    //           return { backgroundColor: red[50] };
    //         }
    //         if (value === true) {
    //           return { backgroundColor: green[50] };
    //         }
    //         return {};
    //     }
    // };

    handleFilters = async (query) => {

        let res = await axios.post("/equipements/filter/get/all", {query})
        console.log('================handleFilters====================');
        console.log({res});
        console.log('====================================');
    }
    displayTags = (tags) => {
        const { IMMO_TAGS } = this.props;
        
        return tags.split(', ').map(tag => IMMO_TAGS && IMMO_TAGS[tag] && `#${IMMO_TAGS[tag].immo_tag_name}`).join(" ")
    }
    render() {
        const { openQR, selected, openUpdate, openDelete, anchorEl, openMenu, openUpdatePics, openPrint } = this.state;
        const { LOCALISATIONS, EQUIPEMENTS } = this.props
        return (
            <Box>
                {openDelete && !isEmpty(selected) &&
                    <DeleteDialog
                        title={"l'equipement"}
                        close={() => this.setState({
                            openDelete: false,
                            selected: {},
                        })}
                        notif={this.props.notif}
                        handleSubmit={this.handleDelete}
                        disabledSubmit={this.props.STATE.equipements.fetching}
                    >
                        Equipement : {selected.equipement_name} <br />
                        Référence: {selected.equipement_ref}
                    </DeleteDialog>
                }
                {openQR && !isEmpty(selected) &&
                    <GenerateQrCode 
                        equipement={selected} 
                        handleClose={()=> this.setState({ openQR: false })}
                    />
                }
                {openUpdate && !isEmpty(selected) &&
                    <Equipements
                        update
                        equipement={this.state.selected}
                        type={this.state.selected.equipement_type}
                        {...this.props}
                        handleClose={() => this.handleOpenUpdate({}, "openUpdate", false)}
                    />
                }
                {openUpdatePics && !isEmpty(selected) &&
                    <EquipementPics
                        update
                        equipement={this.state.selected}
                        type={this.state.selected.equipement_type}
                        {...this.props}
                        handleClose={() => this.handleOpenUpdate({}, "openUpdatePics", false)}
                    />
                }
                {openPrint &&
                    <PrintRefs
                        type={"immo"}
                        {...this.props}
                        closePrint={() => this.setState({openPrint: false})}
                    />
                }
                <Box p={1}>
                    <IconButton onClick={() => this.setState({ openPrint: true })}>
                        <PrintRounded />
                    </IconButton>
                    {/* <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Intitulé</TableCell>
                                <TableCell>Date d'aquisition</TableCell>
                                <TableCell>Référence</TableCell>
                                <TableCell>Localisation</TableCell>
                                <TableCell>Disponible</TableCell>
                                <TableCell>QR Code</TableCell>
                                <TableCell>Options</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {!isEmpty(EQUIPEMENTS) && !isEmpty(LOCALISATIONS.CHILD) && Object.values(EQUIPEMENTS).filter(i => i.equipement_type === "immo").map(equipement =>
                                <TableRow 
                                    style={{ backgroundColor: (equipement.equipement_available ? green[50] : red[50]) }}    
                                >
                                    <TableCell className="a-like" onClick={() => this.props.handleSingle(equipement)}>{equipement.equipement_name}</TableCell>
                                    <TableCell>{new Date(equipement.equipement_date_acquisition).toLocaleDateString("fr-FR")}</TableCell>
                                    <TableCell>{equipement.equipement_ref}</TableCell>
                                    <TableCell>{LOCALISATIONS.CHILD[equipement.equipement_localisation] && LOCALISATIONS.CHILD[equipement.equipement_localisation].loc_name}</TableCell>
                                    <TableCell>
                                        {equipement.equipement_available ? "OUI" : "NON"}
                                    </TableCell>
                                    <TableCell>
                                        <IconButton onClick={ () => this.setState({ openQR : true, selected: equipement })}>
                                            <QrCode2Rounded />
                                        </IconButton>
                                    </TableCell>
                                    <TableCell>
                                        {equipement.equipement_available &&
                                        <>
                                            <IconButton 
                                                aria-controls={`option-menu${equipement.equipement_id}`} 
                                                aria-haspopup="true"
                                                onClick={(event) => this.setState({ anchorEl: event.currentTarget, openMenu : equipement.equipement_id}) }>
                                                <MoreVertRounded />
                                            </IconButton>

                                            <Menu
                                                MenuListProps={{
                                                'aria-labelledby': 'basic-button',
                                                }}
                                                id={`option-menu${equipement.equipement_id}`}
                                                anchorEl={anchorEl}                                               
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'right',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                }}
                                                open={ openMenu === equipement.equipement_id}
                                                onClose={() => this.setState({ openMenu: "", anchorEl: null})}
                                            >
                                                <MenuItem onClick={() => this.handleOpenUpdate(equipement) } >Modifier</MenuItem>                
                                                <MenuItem onClick={() => this.handleOpenUpdate(equipement, "openUpdatePics") } >Modifier Photos</MenuItem>                
                                                {/* <MenuItem 
                                                    onClick={() => this.setState({ 
                                                        deleteEquipement: true, 
                                                        toDelete: equipement, 
                                                        openMenu: "", 
                                                        anchorEl:null
                                                    }) }
                                                >
                                                    Supprimer
                                                </MenuItem>
                                            </Menu>
                                        </>
                                        }
                                    </TableCell>
                                    
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                     */}
                        {this.props.STATE.equipements.fetching && 
                            <Box p={3} style={{margin: "auto", textAlign: "center"}}>
                                <CircularProgress color="secondary" size={80}/>
                            </Box>
                        }
                        <Box>
                            {!isEmpty(EQUIPEMENTS) && !isEmpty(LOCALISATIONS.CHILD) && 
                                <TableWithFilters
                                    internalId="equipement_id"
                                    rows={uniqBy(Object.values(EQUIPEMENTS), "equipement_original_name").filter(i => i.equipement_type !== "vehicule")}
                                    // getRowStyle={this.getRowStyle}
                                    filterList={this.handleFilters}
                                    general
                                    columns={[
                                        {
                                            field: 'equipement_ref',
                                            headerName: 'Référence', 
                                            width: 200,
                                            renderCell: (params) => (
                                                <span 
                                                    onClick={
                                                        params.row.equipement_quantity > 1 ? 
                                                        () => this.props.handleSingleList(params.row) :
                                                        () => this.props.handleSingle(params.row)
                                                    }
                                                >
                                                    {/* {params.row.equipement_ref} */}
                                                    {params.row.equipement_quantity > 1 ?
                                                        params.row.equipement_unique_ref :
                                                        params.row.equipement_ref
                                                    }
                                                </span>
                                            ),
                                        },
                                        
                                        {
                                            field: 'equipement_photo_front',
                                            headerName: 'Photo', 
                                            width: 100,
                                            renderCell: (params) => (
                                                <img 
                                                    style={{maxHeight: "100%"}}
                                                    src={`/photos/single/${params.row[`equipement_photo_front`].filename}`} 
                                                    title={"photo"} 
                                                    alt={"photo"} 
                                                />
                                            ),
                                        },
                                        {
                                            field: 'equipement_original_name',
                                            headerName: 'Intitulé', 
                                            width: 500,
                                            renderCell: (params) => (
                                                <span className="a-like" 
                                                    onClick={
                                                        params.row.equipement_quantity > 1 ? 
                                                        () => this.props.handleSingleList(params.row) :
                                                        () => this.props.handleSingle(params.row)
                                                    }
                                                >
                                                    {params.row.equipement_quantity > 1 &&
                                                        <IconButton><ChevronRightRounded /></IconButton>
                                                    }
                                                    {params.row.equipement_original_name}
                                                </span>
                                            ),
                                        },
                                        {
                                            field: 'equipement_brand',
                                            headerName: 'Marque', 
                                            width: 200,
                                            renderCell: (params) => (
                                                <span 
                                                    className="a-like" 
                                                    onClick={
                                                        params.row.equipement_quantity > 1 ? 
                                                        () => this.props.handleSingleList(params.row) :
                                                        () => this.props.handleSingle(params.row)
                                                    }
                                                >{params.row.equipement_brand}</span>
                                            ),
                                        },
                                        {
                                            field: 'equipement_date_acquisition',
                                            headerName: "Aquisition", 
                                            // valueGetter: (params) => `${new Date(params.row.equipement_date_acquisition).toLocaleDateString("fr-FR")}`,
                                            renderCell: (params) => (
                                                <span>{
                                                    new Date(params.row.equipement_date_acquisition).getFullYear() > 1 ? 
                                                    `${new Date(params.row.equipement_date_acquisition).toLocaleDateString("fr-FR")}` : 
                                                    "--"
                                                }
                                                </span>

                                            ),
                                            width: 150
                                        },
                                        {
                                            field: 'equipement_date_service',
                                            headerName: "Mise en service", 
                                            // valueGetter: (params) => `${new Date(params.row.equipement_date_acquisition)}`,
                                            renderCell: (params) => (
                                                <span>{
                                                    new Date(params.row.equipement_date_service).getFullYear() > 1 ? 
                                                    `${new Date(params.row.equipement_date_service).toLocaleDateString("fr-FR")}` : 
                                                    "--"
                                                }
                                                </span>

                                            ),
                                            width: 150
                                        },
                                        {
                                            field: 'loc',
                                            headerName: 'Localisation', 
                                            width: 150,
                                            sortable: true,
                                            valueGetter: (params) =>
                                            `${LOCALISATIONS.CHILD[params.row.equipement_localisation].loc_name}`,
                                        },
                                        {
                                            field: 'tag',
                                            headerName: 'Tag', 
                                            width: 150,
                                            sortable: true,
                                            valueGetter: (params) => this.displayTags(params.row.equipement_tags),
                                        },
                                        {
                                            field: 'dispo',
                                            headerName: 'Dispo', 
                                            width: 100,
                                            sortable: true,
                                            // valueGetter: (params) => `${params.row.equipement_available ? 'OUI' : 'NON'}`,
                                            // valueGetter: (params) => `${params.row.equipement_available ? 'OUI' : 'NON'}`,
                                            valueGetter: (params) => (
                                                `${find(Object.values(EQUIPEMENTS).filter( item => item.equipement_original_name == params.row.equipement_original_name), "equipement_available") ? "OUI" : "NON"}`
                                            ),
                                        },
                                        {
                                            field: 'qr',
                                            headerName: 'QR code',
                                            width: 100,
                                            sortable: false,
                                            renderCell: (params) => (
                                                <IconButton onClick={ () => this.setState({ openQR : true, selected: params.row })}>
                                                    <QrCode2Rounded />
                                                </IconButton>
                                            ),
                                        },
                                        {
                                            field: 'actions',
                                            headerName: 'Actions',
                                            sortable: false,
                                            width: 100,
                                            renderCell: (params) => (
                                                params.row.equipement_quantity == 1 ?
                                                
                                                <>
                                                <IconButton 
                                                    aria-controls={`option-menu${params.row.equipement_id}`} 
                                                    aria-haspopup="true"
                                                    onClick={(event) => this.setState({ anchorEl: event.currentTarget, openMenu : params.row.equipement_id}) }>
                                                    <MoreVertRounded />
                                                </IconButton>

                                                <Menu
                                                    MenuListProps={{
                                                    'aria-labelledby': 'basic-button',
                                                    }}
                                                    id={`option-menu${params.row.equipement_id}`}
                                                    anchorEl={anchorEl}                                               
                                                    anchorOrigin={{
                                                        vertical: 'bottom',
                                                        horizontal: 'right',
                                                    }}
                                                    transformOrigin={{
                                                        vertical: 'top',
                                                        horizontal: 'right',
                                                    }}
                                                    open={ openMenu === params.row.equipement_id}
                                                    onClose={() => this.setState({ openMenu: "", anchorEl: null})}
                                                >
                                                    {!params.row.equipement_available && !params.row.no_loan &&
                                                        <MenuItem onClick={() => this.props.handleOpenReturn(params.row) } >Restitution</MenuItem>    
                                                    }   
                                                    {params.row.equipement_available &&
                                                        <>    
                                                            <MenuItem onClick={() => this.props.handleOpenAttribute(params.row) } >Attribution</MenuItem>    
                                                            <MenuItem onClick={() => this.handleOpenUpdate(params.row) } >Modifier</MenuItem>                
                                                            <MenuItem onClick={() => this.handleOpenUpdate(params.row, "openUpdatePics") } >Modifier Photos</MenuItem>                
                                                            <MenuItem 
                                                                onClick={() => this.handleOpenUpdate(params.row, "openDelete") }
                                                            >
                                                                Supprimer
                                                            </MenuItem>
                                                        </>
                                                    }
                                                    {params.row.no_loan &&
                                                        <>    
                                                            <MenuItem onClick={() => this.handleOpenUpdate(params.row) } >Modifier</MenuItem>                
                                                            <MenuItem onClick={() => this.handleOpenUpdate(params.row, "openUpdatePics") } >Modifier Photos</MenuItem>                
                                                            <MenuItem 
                                                                onClick={() => this.handleOpenUpdate(params.row, "openDelete") }
                                                            >
                                                                Supprimer
                                                            </MenuItem>
                                                        </>
                                                    }
                                                </Menu>
                                                </>
                                            :
                                            ""
                                            ),
                                        },
                                    ]}
                                />
                            }
                        </Box>
                </Box>
            </Box>
            // <TableCell>Intitulé</TableCell>
            // <TableCell>Date d'aquisition</TableCell>
            // <TableCell>Référence</TableCell>
            // <TableCell>Localisation</TableCell>
            // <TableCell>Disponible</TableCell>
            // <TableCell>QR Code</TableCell>
                
        );
    }
}

export default ImmoList;